import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=47890a90&"
import script from "./contact.vue?vue&type=script&lang=js&"
export * from "./contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextDecoration: require('C:/Users/ABUAQQM/Documents/GitHub/icdc-site/components/TextDecoration.vue').default,ContactForm: require('C:/Users/ABUAQQM/Documents/GitHub/icdc-site/components/ContactForm.vue').default})
